// Import action IDs
import {
    NEW_GAME_SOCKET,
    REFRESH_ROOMS_LIST_SOCKET,
    REFRESH_ROOMS_LIST_LOCAL,
    JOIN_GAME_SOCKET,
    LEAVE_GAME_SOCKET,
    RESET_GAMEMNGT_STATE} from '../actions/gameManagement';

// Init state
const initState = {
    rooms: [],
    roomsExist: false,
    gameroom: '',
    gameRunning: false
};

// Reducer
export const gameMngtReducer = (state = initState, action) =>{
    switch(action.type){
        case NEW_GAME_SOCKET:
            action.socket.emit('room-leave');
            action.socket.emit('room-join-new', action.payload);

            return {
                ...state,
                gameRunning: true
            };

        case REFRESH_ROOMS_LIST_SOCKET:
            action.socket.emit('room-refresh');
            return state;

        case REFRESH_ROOMS_LIST_LOCAL:
            let rooms = [];
            let roomsExist = false;

            rooms = Object.keys(action.payload.rooms);
            if(rooms.length >=1){
                roomsExist=true;
            }

            return {
                ...state,
                roomsExist,
                rooms,
            };

        case JOIN_GAME_SOCKET:
            action.socket.emit('room-join-existing', action.payload);
            return {
                ...state,
                gameRunning: true,
                gameroom: action.payload.gameroom
            };

        case LEAVE_GAME_SOCKET:
            action.payload.socket.emit('room-leave', action.payload.gameroom);

            return {
                ...state,
                gameroom: '',
                gameRunning: false
            };

        case RESET_GAMEMNGT_STATE:
            console.log(RESET_GAMEMNGT_STATE);
            return {
                ...state,
                gameroom: '',
                gameRunning: false
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/gameManagement.js